
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Message from '@/components/message.vue';
  import {
    memberMessagememberMessageNoticeList,
    memberMessagememberMessageNoticeSend,
    wxappwxappgenerateurllink
  } from "@/api/material"
  import Dialog from '@/components/dialog.vue';
	import ChoosePages from '@/components/choosepages/choosepages.vue';
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-message': Message,
      'slz-dialog': Dialog,
      ChoosePages,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:0,label:'未推送'},
      {value:1,label:'已推送'},
    ]
    private tablelist:any = []
    private tableloading = false
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private pushShow = false
    private rowmsg:any = {}
    private createShow = false
    private chooseShow = false
    private choosemsg:any = {}

    private mounted () {
      this.gettablelist()
    }


    private async createLink(){
      try{
        let data = this.choosemsg.pageurl.split('?')
        let res = await wxappwxappgenerateurllink({
          Path:data[0],
          query:data[1],
          env_version:location.origin == 'http://testbackend.routuan.com'?'develop':'release'
        })
        if(res.IsSuccess){
          this.choosemsg.link = res.Result.url_link
        }
      }finally{
        //
      }
    }
    private copy(e){
      
      handleClipboard(this.choosemsg.link,e)
    }
    private getdata(e){
      this.choosemsg = {
        ...e,
        link:''
      }
      // console.log(this.choosemsg)
      this.chooseShow = false
    }
    private toGenerate(){
      this.createShow = true
    }
    private toedit(row){
      this.$router.push({
        path:'pushmanagementEdit',
        query:{
          Id:row.Id
        }
      })
    }
    private async confirmPush(){
      try{
        let res:any = await memberMessagememberMessageNoticeSend({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private pushNow(row){
      this.rowmsg = row
      this.pushShow = true
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.changePage(1)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywords:this.keywords,
          PushState:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let res:any = await memberMessagememberMessageNoticeList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
